import { createFileRoute } from "@tanstack/react-router";
import * as Sentry from "@sentry/tanstackstart-react";
import { useState } from "react";

export const Route = createFileRoute("/dev/sentry-test")({
  component: SentryTestPage,
});

/**
 * Dev-only Sentry verification — not linked from product navigation.
 * Throws / captures a tagged test exception for the web project.
 */
function SentryTestPage() {
  const [sent, setSent] = useState(false);

  if (!import.meta.env.DEV) {
    return (
      <div className="grid min-h-screen place-items-center p-6 text-sm text-muted-foreground">
        Nur im Dev-Modus verfügbar.
      </div>
    );
  }

  return (
    <div className="mx-auto flex min-h-screen max-w-lg flex-col justify-center gap-4 p-6">
      <h1 className="text-xl font-semibold">Sentry test (web)</h1>
      <p className="text-sm text-muted-foreground">
        Environment: {import.meta.env.VITE_SENTRY_ENVIRONMENT || "(auto)"} · DSN{" "}
        {import.meta.env.VITE_SENTRY_DSN ? "gesetzt" : "fehlt"}
      </p>
      <button
        type="button"
        className="rounded-xl bg-foreground px-4 py-3 text-sm font-semibold text-background"
        onClick={() => {
          Sentry.captureException(new Error("Sentry Test Error"), {
            tags: { pulse_sentry_test: "web", source: "captureException" },
          });
          setSent(true);
        }}
      >
        Capture test exception
      </button>
      <button
        type="button"
        className="rounded-xl border border-border px-4 py-3 text-sm font-semibold"
        onClick={() => {
          throw new Error("Sentry Test Error");
        }}
      >
        Throw uncaught (boundary)
      </button>
      {sent ? (
        <p className="text-sm text-muted-foreground">
          Event gesendet — in Sentry Issues prüfen (Projekt javascript-tanstackstart-react, Tag
          pulse_sentry_test=web).
        </p>
      ) : null}
    </div>
  );
}
